import script from "./RegisterBusinessPageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterBusinessPageTab.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterBusinessPageTab.vue?vue&type=style&index=0&id=5f9e31a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9e31a2"]])

export default __exports__